import { connect } from '@ardoq/rxbeach';
import { MetamodelView } from 'metamodel/MetamodelView';
import { metamodelNavigation$ } from 'metamodel/navigation/metamodelNavigation$';
import {
  APIFieldAttributes,
  APIFieldType,
  PersistedMetamodel,
} from '@ardoq/api-types';
import { MetamodelContext } from 'metamodel/types';
import { handleSelectMetamodelItem } from '../../metamodel/navigation/routines';
import { type I18nLocale } from '@ardoq/i18n';
import { type Locale } from '@ardoq/locale';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { fields$ } from 'streams/fields/fields$';
import { getNonTemplateFieldsByName } from 'streams/fields/getNonTemplateFieldsByName';
import { locale$ } from 'streams/locale$';
import { isPptxExportRunning$ } from 'presentation/pptxExport/pptxExport$';
import {
  registerVisualizationContainer,
  toRegisterGraphComponent,
  unregisterGraphComponent,
  unregisterVisualizationContainer,
} from 'presentation/pptxExport/slideCaptureSurfaceDispatchers';

// TODO(ARD-31568) Threads only an empty `I18nLocale` so MetamodelView
// renders with English fallbacks inside the live presentation slide. The
// presentation playback chrome itself is tracked as part of the deferred
// presentation/main-view i18n pass, not the metamodel-admin migration.
const NO_LOCALE: I18nLocale = {};

const MetamodelSlideBase = ({
  metamodel,
  context,
  infoContainerIsOpen,
  infoContainerWidth,
  isCheckboxField,
  nonTemplateFieldsByName,
  locale,
  isExporting,
}: {
  metamodel?: PersistedMetamodel;
  context: MetamodelContext;
  infoContainerIsOpen: boolean;
  infoContainerWidth: number;
  isCheckboxField: boolean;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  locale: Locale;
  isExporting: boolean;
}) => {
  if (!metamodel) return null;
  return (
    <MetamodelView
      key={metamodel._id}
      metamodel={metamodel}
      context={context}
      infoContainerIsOpen={infoContainerIsOpen}
      infoContainerWidth={infoContainerWidth}
      isCheckboxField={isCheckboxField}
      nonTemplateFieldsByName={nonTemplateFieldsByName}
      locale={locale}
      i18nLocale={NO_LOCALE}
      registerGraphComponent={toRegisterGraphComponent(metamodel._id)}
      unregisterGraphComponent={unregisterGraphComponent}
      registerVisualizationContainer={registerVisualizationContainer}
      unregisterVisualizationContainer={unregisterVisualizationContainer}
      animateLayout={!isExporting}
    />
  );
};

export const MetamodelSlide = connect(
  MetamodelSlideBase,
  combineLatest([
    metamodelNavigation$,
    fields$,
    locale$,
    isPptxExportRunning$,
  ]).pipe(
    map(
      ([
        { metamodel, context, infoContainerIsOpen, infoContainerWidth },
        fields,
        locale,
        isExporting,
      ]) => ({
        metamodel,
        context,
        infoContainerIsOpen,
        infoContainerWidth,
        isCheckboxField:
          'field' in context && context.field
            ? fields.byName.get(context.field)?.type === APIFieldType.CHECKBOX
            : false,
        nonTemplateFieldsByName: getNonTemplateFieldsByName(fields.byName),
        locale,
        isExporting,
      })
    )
  ),
  handleSelectMetamodelItem
);
